import request from '@/utils/request'

export function getList(params) {
  return request({
    url: 'cancelReason/search',
    method: 'post',
    data: params
  })
}

export function addReason(params) {
  return request({
    url: 'cancelReason',
    method: 'post',
    data: params
  })
}

export function editReason(id, params) {
  return request({
    url: 'cancelReason/edit/' + id,
    method: 'post',
    data: params
  })
}
